<template>
  <NavBar pageName="Settings"></NavBar>
  <v-container style="margin-top: 185px;">
    <v-row>
      <v-col cols="12" md="8" lg="6">
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2">mdi-monitor-eye</v-icon>
            Display Settings
          </v-card-title>
          <v-card-subtitle>Configurare numar inregistrari afisate per pagina in listele principale</v-card-subtitle>
          <v-card-text>
            <v-table>
              <thead>
                <tr>
                  <th>Entitate</th>
                  <th style="width: 200px;">Inregistrari per pagina</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in settingsItems" :key="item.key">
                  <td>
                    <v-icon size="small" class="mr-2" :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.label }}
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="form[item.key]"
                      type="number"
                      density="compact"
                      variant="outlined"
                      hide-details
                      :min="1"
                      :max="500"
                      style="max-width: 150px;"
                    />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" variant="elevated" :loading="saving" @click="save">
              <v-icon class="mr-1">mdi-content-save</v-icon>
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import { getDisplaySettings, updateDisplaySettings } from '@/composables/useDisplaySettingsAPI'
import store from '@/store'

export default {
  name: 'DisplaySettings',
  components: { NavBar },
  data() {
    return {
      form: {
        default_page_size_sims: 20,
        default_page_size_imsis: 20,
        default_page_size_msisdns: 20,
        default_page_size_clients: 20
      },
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      settingsItems: [
        { key: 'default_page_size_sims', label: 'SIM-uri', icon: 'mdi-sim', color: 'blue' },
        { key: 'default_page_size_imsis', label: 'IMSI', icon: 'mdi-card-bulleted', color: 'teal' },
        { key: 'default_page_size_msisdns', label: 'MSISDN (Numere telefon)', icon: 'mdi-phone', color: 'green' },
        { key: 'default_page_size_clients', label: 'Clienti', icon: 'mdi-account-group', color: 'purple' }
      ]
    }
  },
  computed: {
    token() { return store.getters.getToken }
  },
  async mounted() {
    await this.loadSettings()
  },
  methods: {
    async loadSettings() {
      const result = await getDisplaySettings(this.token)
      if (!result.error && result.display_settings) {
        const ds = result.display_settings
        this.form.default_page_size_sims = ds.default_page_size_sims || 20
        this.form.default_page_size_imsis = ds.default_page_size_imsis || 20
        this.form.default_page_size_msisdns = ds.default_page_size_msisdns || 20
        this.form.default_page_size_clients = ds.default_page_size_clients || 20
      }
    },
    async save() {
      this.saving = true
      try {
        // Clamp values between 1 and 500
        const settings = {}
        Object.keys(this.form).forEach(key => {
          settings[key] = Math.max(1, Math.min(500, this.form[key] || 20))
        })

        const result = await updateDisplaySettings(this.token, settings)
        if (result.error) {
          this.showSnackbar(result.message || 'Eroare la salvare', 'error')
        } else {
          // Update store cache
          store.commit('setDisplaySettings', settings)
          this.showSnackbar('Setari salvate cu succes!', 'success')
        }
      } finally {
        this.saving = false
      }
    },
    showSnackbar(text, color) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  }
}
</script>
